import { useState } from 'react'

const useFormInput = initialValue => {
  const [value, setValue] = useState(initialValue)
  function handleChange (input) {
    if (!input) {
      setValue(initialValue)
    } else if (Array.isArray(input)) {
      const multipleInput = input.map(partial => partial.value).join(' ')
      setValue(multipleInput)
    } else if (input.target) {
      setValue(input.target.value)
    } else {
      setValue(input.value)
    }
  }
  return {
    value,
    onChange: handleChange
  }
}

export {
  useFormInput
}
